require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./post-windows-10-uwp-web-wrapper-app-release.json") })
        }
      }, "path---post-windows-10-uwp-web-wrapper-app-release");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---post-windows-10-uwp-web-wrapper-app-release!./.cache/json/post-windows-10-uwp-web-wrapper-app-release.json
// module id = 370
// module chunks = 231608221292675